import { Stack, Text } from "@chakra-ui/react";
import { FC, useState } from "react";

import CustomLink from "components/Chakra/CustomLink";
import Phone from "components/Chakra/Icons/Phone";
import { formatTelNumber } from "helpers/global";

type IProps = {
  phoneNumber: string;
  onPhoneClick?: () => void;
};

const PhoneNumberSwitch: FC<IProps> = ({ phoneNumber, onPhoneClick }) => {
  const [isShowPhone, setIsShowPhone] = useState(false);

  return (
    <Stack
      spacing={1.5}
      direction="row"
      data-test="phoneNumberSwitch"
      as="button"
    >
      <Phone alignSelf="center" fill="ud-primary" />

      {!isShowPhone ? (
        <Text
          variant="large_1"
          cursor="pointer"
          color="ud-primary"
          onClick={(e) => {
            e.preventDefault();
            setIsShowPhone(true);
          }}
        >
          Zobrazit telefonní číslo
        </Text>
      ) : (
        <CustomLink
          fontSize="16px"
          color="ud-grey-600"
          cursor="pointer"
          href={`tel:${formatTelNumber(phoneNumber)}`}
          onClick={(e) => {
            if (onPhoneClick) {
              e.preventDefault();
              onPhoneClick();

              window.location.href = `tel:${formatTelNumber(phoneNumber)}`;
            }
          }}
        >
          {formatTelNumber(phoneNumber)}
        </CustomLink>
      )}
    </Stack>
  );
};
export default PhoneNumberSwitch;
